import React from 'react';

const InfluencerFilters = ({ filters, setFilters, filterOptions }) => {
  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
  };

  const safeFilterOptions = filterOptions || {
    objectives: ['All'],
    platforms: ['All'],
    geographies: ['All'],
    riskLevels: ['All']
  };

  return (
    <div className="filters-bar">
      <div className="filters-label">
        <span className="filter-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
          </svg>
        </span>
        <span>Filters:</span>
      </div>
      
      <div className="filter-group">
        <label>Objective:</label>
        <select
          className="filter-select"
          value={filters.objective}
          onChange={(e) => handleFilterChange('objective', e.target.value)}
        >
          {safeFilterOptions.objectives.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      
      <div className="filter-group">
        <label>Platform:</label>
        <select
          className="filter-select"
          value={filters.platform}
          onChange={(e) => handleFilterChange('platform', e.target.value)}
        >
          {safeFilterOptions.platforms.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      
      <div className="filter-group">
        <label>Geography:</label>
        <select
          className="filter-select"
          value={filters.geography}
          onChange={(e) => handleFilterChange('geography', e.target.value)}
        >
          {safeFilterOptions.geographies.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      
      <div className="filter-group">
        <label>Risk:</label>
        <select
          className="filter-select"
          value={filters.risk}
          onChange={(e) => handleFilterChange('risk', e.target.value)}
        >
          {safeFilterOptions.riskLevels.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default InfluencerFilters;
